import { render } from "./AnimalInfo.vue?vue&type=template&id=66c15ffa"
import script from "./AnimalInfo.vue?vue&type=script&lang=js"
export * from "./AnimalInfo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__